import React from 'react';
import { Widgets } from 'Utils/Widgets/Widgets';
import MapWidgetWrapper from '../Components/MapWidgetWrapper';
import { WidgetCard } from '../Components/WidgetCard';
import {
  temperatureWidgetData,
  windWidgetData,
  atmospherePressureVCWidgetData,
  humidityVCWidgetData,
  visibilityVCWidgetData,
  windRoseArrowVCWidgetData,
  windRoseChartVSWidgetData,
  complexVCChart1,
  complexVCChart2,
  complexVCChart3,
} from './visualCrossingWidgetData';
import { WindRoseChartWrapper } from '../Components/WindRoseChartWrapper';
import { WidgetChart } from '../Components/WidgetChart';

export default function VisualCrossingMonitor() {
  return (
    <div style={{
      margin: '.5rem',
      maxWidth: '1000px',
      width: '1000px',
      display: 'grid',
      gridTemplateRows: 'repeat(2,max-content) 1fr',
      gap: '1rem',
      justifySelf: 'center',
    }}
    >
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gridGap: '.5rem', gridTemplateRows: 'max-content' }}>
        <WidgetCard
          widgetData={temperatureWidgetData}
          widgetLayout={Widgets.Temperature}
        />
        <WidgetCard
          widgetData={windWidgetData}
          widgetLayout={Widgets.Wind}
        />
        <WidgetCard
          widgetData={visibilityVCWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={humidityVCWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
        <WidgetCard
          widgetData={atmospherePressureVCWidgetData}
          widgetLayout={Widgets.Common}
          isCommon
        />
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', columnGap: '.5rem' }}>
        <WindRoseChartWrapper
          windRoseChartWidgetData={windRoseChartVSWidgetData}
          windRoseWidgetArrowWidgetData={windRoseArrowVCWidgetData}
        />
        <MapWidgetWrapper />
      </div>
      <div style={{
        display: 'grid',
        gridAutoFlow: 'row',
        gridAutoRows: '1fr',
        width: '100%',
      }}
      >
        <WidgetChart
          chartDatasetInfo={complexVCChart1}
        />
        <WidgetChart
          chartDatasetInfo={complexVCChart2}
        />
        <WidgetChart
          chartDatasetInfo={complexVCChart3}
          isModLinear
        />
      </div>
    </div>
  );
}
